const htmlEntitiesMap = new Map<string, string>()

htmlEntitiesMap.set('&apos;', "'")
htmlEntitiesMap.set('&lt;', '<')
htmlEntitiesMap.set('&gt;', '>')
htmlEntitiesMap.set('&nbsp;', ' ')
htmlEntitiesMap.set('&iexcl;', '¡')
htmlEntitiesMap.set('&cent;', '¢')
htmlEntitiesMap.set('&pound;', '£')
htmlEntitiesMap.set('&curren;', '¤')
htmlEntitiesMap.set('&yen;', '¥')
htmlEntitiesMap.set('&brvbar;', '¦')
htmlEntitiesMap.set('&sect;', '§')
htmlEntitiesMap.set('&uml;', '¨')
htmlEntitiesMap.set('&copy;', '©')
htmlEntitiesMap.set('&ordf;', 'ª')
htmlEntitiesMap.set('&laquo;', '«')
htmlEntitiesMap.set('&not;', '¬')
htmlEntitiesMap.set('&reg;', '®')
htmlEntitiesMap.set('&macr;', '¯')
htmlEntitiesMap.set('&deg;', '°')
htmlEntitiesMap.set('&plusmn;', '±')
htmlEntitiesMap.set('&sup2;', '²')
htmlEntitiesMap.set('&sup3;', '³')
htmlEntitiesMap.set('&acute;', '´')
htmlEntitiesMap.set('&micro;', 'µ')
htmlEntitiesMap.set('&para;', '¶')
htmlEntitiesMap.set('&middot;', '·')
htmlEntitiesMap.set('&cedil;', '¸')
htmlEntitiesMap.set('&sup1;', '¹')
htmlEntitiesMap.set('&ordm;', 'º')
htmlEntitiesMap.set('&raquo;', '»')
htmlEntitiesMap.set('&frac14;', '¼')
htmlEntitiesMap.set('&frac12;', '½')
htmlEntitiesMap.set('&frac34;', '¾')
htmlEntitiesMap.set('&iquest;', '¿')
htmlEntitiesMap.set('&Agrave;', 'À')
htmlEntitiesMap.set('&Aacute;', 'Á')
htmlEntitiesMap.set('&Acirc;', 'Â')
htmlEntitiesMap.set('&Atilde;', 'Ã')
htmlEntitiesMap.set('&Auml;', 'Ä')
htmlEntitiesMap.set('&Aring;', 'Å')
htmlEntitiesMap.set('&AElig;', 'Æ')
htmlEntitiesMap.set('&Ccedil;', 'Ç')
htmlEntitiesMap.set('&Egrave;', 'È')
htmlEntitiesMap.set('&Eacute;', 'É')
htmlEntitiesMap.set('&Ecirc;', 'Ê')
htmlEntitiesMap.set('&Euml;', 'Ë')
htmlEntitiesMap.set('&Igrave;', 'Ì')
htmlEntitiesMap.set('&Iacute;', 'Í')
htmlEntitiesMap.set('&Icirc;', 'Î')
htmlEntitiesMap.set('&Iuml;', 'Ï')
htmlEntitiesMap.set('&ETH;', 'Ð')
htmlEntitiesMap.set('&Ntilde;', 'Ñ')
htmlEntitiesMap.set('&Ograve;', 'Ò')
htmlEntitiesMap.set('&Oacute;', 'Ó')
htmlEntitiesMap.set('&Ocirc;', 'Ô')
htmlEntitiesMap.set('&Otilde;', 'Õ')
htmlEntitiesMap.set('&Ouml;', 'Ö')
htmlEntitiesMap.set('&times;', '×')
htmlEntitiesMap.set('&Oslash;', 'Ø')
htmlEntitiesMap.set('&Ugrave;', 'Ù')
htmlEntitiesMap.set('&Uacute;', 'Ú')
htmlEntitiesMap.set('&Ucirc;', 'Û')
htmlEntitiesMap.set('&Uuml;', 'Ü')
htmlEntitiesMap.set('&Yacute;', 'Ý')
htmlEntitiesMap.set('&THORN;', 'Þ')
htmlEntitiesMap.set('&szlig;', 'ß')
htmlEntitiesMap.set('&agrave;', 'à')
htmlEntitiesMap.set('&aacute;', 'á')
htmlEntitiesMap.set('&acirc;', 'â')
htmlEntitiesMap.set('&atilde;', 'ã')
htmlEntitiesMap.set('&auml;', 'ä')
htmlEntitiesMap.set('&aring;', 'å')
htmlEntitiesMap.set('&aelig;', 'æ')
htmlEntitiesMap.set('&ccedil;', 'ç')
htmlEntitiesMap.set('&egrave;', 'è')
htmlEntitiesMap.set('&eacute;', 'é')
htmlEntitiesMap.set('&ecirc;', 'ê')
htmlEntitiesMap.set('&euml;', 'ë')
htmlEntitiesMap.set('&igrave;', 'ì')
htmlEntitiesMap.set('&iacute;', 'í')
htmlEntitiesMap.set('&icirc;', 'î')
htmlEntitiesMap.set('&iuml;', 'ï')
htmlEntitiesMap.set('&eth;', 'ð')
htmlEntitiesMap.set('&ntilde;', 'ñ')
htmlEntitiesMap.set('&ograve;', 'ò')
htmlEntitiesMap.set('&oacute;', 'ó')
htmlEntitiesMap.set('&ocirc;', 'ô')
htmlEntitiesMap.set('&otilde;', 'õ')
htmlEntitiesMap.set('&ouml;', 'ö')
htmlEntitiesMap.set('&divide;', '÷')
htmlEntitiesMap.set('&oslash;', 'ø')
htmlEntitiesMap.set('&ugrave;', 'ù')
htmlEntitiesMap.set('&uacute;', 'ú')
htmlEntitiesMap.set('&ucirc;', 'û')
htmlEntitiesMap.set('&uuml;', 'ü')
htmlEntitiesMap.set('&yacute;', 'ý')
htmlEntitiesMap.set('&thorn;', 'þ')
htmlEntitiesMap.set('&yuml;', 'ÿ')
htmlEntitiesMap.set('&OElig;', 'Œ')
htmlEntitiesMap.set('&oelig;', 'œ')
htmlEntitiesMap.set('&Scaron;', 'Š')
htmlEntitiesMap.set('&scaron;', 'š')
htmlEntitiesMap.set('&Yuml;', 'Ÿ')
htmlEntitiesMap.set('&fnof;', 'ƒ')
htmlEntitiesMap.set('&circ;', 'ˆ')
htmlEntitiesMap.set('&tilde;', '˜')
htmlEntitiesMap.set('&Alpha;', 'Α')
htmlEntitiesMap.set('&Beta;', 'Β')
htmlEntitiesMap.set('&Gamma;', 'Γ')
htmlEntitiesMap.set('&Delta;', 'Δ')
htmlEntitiesMap.set('&Epsilon;', 'Ε')
htmlEntitiesMap.set('&Zeta;', 'Ζ')
htmlEntitiesMap.set('&Eta;', 'Η')
htmlEntitiesMap.set('&Theta;', 'Θ')
htmlEntitiesMap.set('&Iota;', 'Ι')
htmlEntitiesMap.set('&Kappa;', 'Κ')
htmlEntitiesMap.set('&Lambda;', 'Λ')
htmlEntitiesMap.set('&Mu;', 'Μ')
htmlEntitiesMap.set('&Nu;', 'Ν')
htmlEntitiesMap.set('&Xi;', 'Ξ')
htmlEntitiesMap.set('&Omicron;', 'Ο')
htmlEntitiesMap.set('&Pi;', 'Π')
htmlEntitiesMap.set('&Rho;', 'Ρ')
htmlEntitiesMap.set('&Sigma;', 'Σ')
htmlEntitiesMap.set('&Tau;', 'Τ')
htmlEntitiesMap.set('&Upsilon;', 'Υ')
htmlEntitiesMap.set('&Phi;', 'Φ')
htmlEntitiesMap.set('&Chi;', 'Χ')
htmlEntitiesMap.set('&Psi;', 'Ψ')
htmlEntitiesMap.set('&Omega;', 'Ω')
htmlEntitiesMap.set('&alpha;', 'α')
htmlEntitiesMap.set('&beta;', 'β')
htmlEntitiesMap.set('&gamma;', 'γ')
htmlEntitiesMap.set('&delta;', 'δ')
htmlEntitiesMap.set('&epsilon;', 'ε')
htmlEntitiesMap.set('&zeta;', 'ζ')
htmlEntitiesMap.set('&eta;', 'η')
htmlEntitiesMap.set('&theta;', 'θ')
htmlEntitiesMap.set('&iota;', 'ι')
htmlEntitiesMap.set('&kappa;', 'κ')
htmlEntitiesMap.set('&lambda;', 'λ')
htmlEntitiesMap.set('&mu;', 'μ')
htmlEntitiesMap.set('&nu;', 'ν')
htmlEntitiesMap.set('&xi;', 'ξ')
htmlEntitiesMap.set('&omicron;', 'ο')
htmlEntitiesMap.set('&pi;', 'π')
htmlEntitiesMap.set('&rho;', 'ρ')
htmlEntitiesMap.set('&sigmaf;', 'ς')
htmlEntitiesMap.set('&sigma;', 'σ')
htmlEntitiesMap.set('&tau;', 'τ')
htmlEntitiesMap.set('&upsilon;', 'υ')
htmlEntitiesMap.set('&phi;', 'φ')
htmlEntitiesMap.set('&chi;', 'χ')
htmlEntitiesMap.set('&psi;', 'ψ')
htmlEntitiesMap.set('&omega;', 'ω')
htmlEntitiesMap.set('&thetasym;', 'ϑ')
htmlEntitiesMap.set('&Upsih;', 'ϒ')
htmlEntitiesMap.set('&piv;', 'ϖ')
htmlEntitiesMap.set('&ndash;', '–')
htmlEntitiesMap.set('&mdash;', '—')
htmlEntitiesMap.set('&lsquo;', '‘')
htmlEntitiesMap.set('&rsquo;', '’')
htmlEntitiesMap.set('&sbquo;', '‚')
htmlEntitiesMap.set('&ldquo;', '“')
htmlEntitiesMap.set('&rdquo;', '”')
htmlEntitiesMap.set('&bdquo;', '„')
htmlEntitiesMap.set('&dagger;', '†')
htmlEntitiesMap.set('&Dagger;', '‡')
htmlEntitiesMap.set('&bull;', '•')
htmlEntitiesMap.set('&hellip;', '…')
htmlEntitiesMap.set('&permil;', '‰')
htmlEntitiesMap.set('&prime;', '′')
htmlEntitiesMap.set('&Prime;', '″')
htmlEntitiesMap.set('&lsaquo;', '‹')
htmlEntitiesMap.set('&rsaquo;', '›')
htmlEntitiesMap.set('&oline;', '‾')
htmlEntitiesMap.set('&frasl;', '⁄')
htmlEntitiesMap.set('&euro;', '€')
htmlEntitiesMap.set('&image;', 'ℑ')
htmlEntitiesMap.set('&weierp;', '℘')
htmlEntitiesMap.set('&real;', 'ℜ')
htmlEntitiesMap.set('&trade;', '™')
htmlEntitiesMap.set('&alefsym;', 'ℵ')
htmlEntitiesMap.set('&larr;', '←')
htmlEntitiesMap.set('&uarr;', '↑')
htmlEntitiesMap.set('&rarr;', '→')
htmlEntitiesMap.set('&darr;', '↓')
htmlEntitiesMap.set('&harr;', '↔')
htmlEntitiesMap.set('&crarr;', '↵')
htmlEntitiesMap.set('&lArr;', '⇐')
htmlEntitiesMap.set('&UArr;', '⇑')
htmlEntitiesMap.set('&rArr;', '⇒')
htmlEntitiesMap.set('&dArr;', '⇓')
htmlEntitiesMap.set('&hArr;', '⇔')
htmlEntitiesMap.set('&forall;', '∀')
htmlEntitiesMap.set('&part;', '∂')
htmlEntitiesMap.set('&exist;', '∃')
htmlEntitiesMap.set('&empty;', '∅')
htmlEntitiesMap.set('&nabla;', '∇')
htmlEntitiesMap.set('&isin;', '∈')
htmlEntitiesMap.set('&notin;', '∉')
htmlEntitiesMap.set('&ni;', '∋')
htmlEntitiesMap.set('&prod;', '∏')
htmlEntitiesMap.set('&sum;', '∑')
htmlEntitiesMap.set('&minus;', '−')
htmlEntitiesMap.set('&lowast;', '∗')
htmlEntitiesMap.set('&radic;', '√')
htmlEntitiesMap.set('&prop;', '∝')
htmlEntitiesMap.set('&infin;', '∞')
htmlEntitiesMap.set('&ang;', '∠')
htmlEntitiesMap.set('&and;', '∧')
htmlEntitiesMap.set('&or;', '∨')
htmlEntitiesMap.set('&cap;', '∩')
htmlEntitiesMap.set('&cup;', '∪')
htmlEntitiesMap.set('&int;', '∫')
htmlEntitiesMap.set('&there4;', '∴')
htmlEntitiesMap.set('&sim;', '∼')
htmlEntitiesMap.set('&cong;', '≅')
htmlEntitiesMap.set('&asymp;', '≈')
htmlEntitiesMap.set('&ne;', '≠')
htmlEntitiesMap.set('&equiv;', '≡')
htmlEntitiesMap.set('&le;', '≤')
htmlEntitiesMap.set('&ge;', '≥')
htmlEntitiesMap.set('&sub;', '⊂')
htmlEntitiesMap.set('&sup;', '⊃')
htmlEntitiesMap.set('&nsub;', '⊄')
htmlEntitiesMap.set('&sube;', '⊆')
htmlEntitiesMap.set('&supe;', '⊇')
htmlEntitiesMap.set('&oplus;', '⊕')
htmlEntitiesMap.set('&otimes;', '⊗')
htmlEntitiesMap.set('&perp;', '⊥')
htmlEntitiesMap.set('&sdot;', '⋅')
htmlEntitiesMap.set('&lceil;', '⌈')
htmlEntitiesMap.set('&rceil;', '⌉')
htmlEntitiesMap.set('&lfloor;', '⌊')
htmlEntitiesMap.set('&rfloor;', '⌋')
htmlEntitiesMap.set('&lang;', '⟨')
htmlEntitiesMap.set('&rang;', '⟩')
htmlEntitiesMap.set('&loz;', '◊')
htmlEntitiesMap.set('&spades;', '♠')
htmlEntitiesMap.set('&clubs;', '♣')
htmlEntitiesMap.set('&hearts;', '♥')
htmlEntitiesMap.set('&diams;', '♦')
htmlEntitiesMap.set('&quot;', '"')
htmlEntitiesMap.set('&amp;', '&')

export function decodeHtmlEntities (textEncode:string):string {
  htmlEntitiesMap.forEach((value, key) => {
    const regex = new RegExp(key, 'g')
    textEncode = textEncode.replace(regex, value)
  })

  return textEncode
}
